/**
 * Core: Helpers.
 * -----------------------------------------------------------------------------
 * - Helper functions relating to core functionality.
 */
/**
 * Return a dynamic import for a given Vue component
 * @param {string} handle - A given handle for a Vue component.
 * @returns {object}
 */
import { defineAsyncComponent } from 'vue'

/**
 * Dynamically import a Vue component.
 * - This will only work if the component is in the `components` directory,
 *   due to limitations of async imports.a
 * - If using `defineAsyncComponent` in a component, it *must* include
 *   `webpackChunkName`, as-per below.
 * @see [source](https://github.com/rollup/plugins/tree/master/packages/dynamic-import-vars#limitations)
 * @param {string} handle - Unique handle for a component.
 * @returns {object}
 */
export function importComponent(handle) {
  return defineAsyncComponent({
    loader: () => import(
      /* webpackChunkName: 'component.[request]' */
      `~components/${handle}/${handle}.vue`
    ),
  })
}
